import React, { ReactNode, useEffect, useState } from 'react';

import { COOKIE_CONSENT, YEAR_IN_SECONDS, getAnalyticsData, setCookies } from 'helpers/cookie-helper';
import { Header } from 'components/Header';
import { ContactUs } from 'components/Contact-us';
import { CookiesAgreement } from 'components/Cookies';

import { FormProps } from '../../interfaces';
import { URLEnums } from '../../enum/URLEnum';
import Layout from './Layout';
import { FacebookUrl, LinkedinUrl, TwitterUrl } from '../../../config/constants';
import { LayoutContext } from './context/layout-context';

interface Props {
  children?: ReactNode;
  isForm?: boolean;
  isBasicLayout?: boolean;
  className?: string;
  TextareaDefaultValue?: string;
  layoutClass?: string;
  showCookieBanner?: boolean;
}

export const LayoutCom: React.FC<Props & FormProps> = ({
  children,
  isBasicLayout = false,
  isForm = false,
  className = '',
  TextareaDefaultValue = '',
  layoutClass = '',
  showCookieBanner = true,
}: Props) => {
  const [activeAll, setActiveAll] = useState(false);

  useEffect(() => {
    async function updateAnalyticsData() {
      const analyticsData = await getAnalyticsData();

      (window as any).dataLayer?.push({
        event: 'route_changed',
        ...analyticsData,
      });
    }

    updateAnalyticsData();
  }, []);

  const handleCookieAgreeButton = () => {
    setActiveAll(!activeAll);
    setCookies(COOKIE_CONSENT, 'true', { maxAge: YEAR_IN_SECONDS });
  };

  return (
    <LayoutContext.Provider value={isForm}>
      <Layout
        attachments={[{ title: 'Privacy notice', link: URLEnums.PrivacyPolicy }]}
        socialMediaUrls={[FacebookUrl, LinkedinUrl, TwitterUrl]}
        content={
          <>
            <Header />
            {!isBasicLayout && <ContactUs TextareaDefaultValue={TextareaDefaultValue} isForm={isForm} />}
            {showCookieBanner && <CookiesAgreement toggleToggles={handleCookieAgreeButton} />}
          </>
        }
        className={className}
        layoutClass={layoutClass}
      >
        {children}
      </Layout>
    </LayoutContext.Provider>
  );
};
